import React from 'react';
import PageTransition from '../components/PageTransition';
import routes from '../messages/routes';
import { steps } from '../utils/routes';
import PurchasePremium from '../views/PurchasePremium';
import NotFoundPage from '../pages/404';

const PurchasePremiumPage = () => (
  <PageTransition basepath={'/'} showStepper={false} hideMenu>
    <PurchasePremium path={routes[steps.PurchasePremium]} />
    <NotFoundPage default />
  </PageTransition>
);

PurchasePremiumPage.propTypes = {};

export default PurchasePremiumPage;
